"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FileUpload = _interopRequireDefault(require("../../../FileUpload"));
var _withLogic = _interopRequireDefault(require("../withLogic"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var FileUpload = (0, _styledComponents["default"])(_FileUpload["default"]).attrs(function (_ref) {
  var form = _ref.form,
    name = _ref.name;
  return {
    onChange: function onChange(fieldValue) {
      return form.setFieldValue(name, fieldValue);
    }
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
FileUpload.propTypes = {
  placeholder: _propTypes["default"].string
};
var _default = exports["default"] = (0, _withLogic["default"])(FileUpload);